import { render, staticRenderFns } from "./liveSetting.vue?vue&type=template&id=246a349d&scoped=true&"
import script from "./liveSetting.vue?vue&type=script&lang=js&"
export * from "./liveSetting.vue?vue&type=script&lang=js&"
import style0 from "./liveSetting.vue?vue&type=style&index=0&id=246a349d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a349d",
  null
  
)

export default component.exports